<template>
    <div class="request-handling-supplier mt-2">
        <SupplierSelector
            border-variant="light"
            :selected="details.suppliers"
            :add-button-label="addSupplierLabel"
            @change="changeSuppliers"
        >
            <template #after-selection>
                <Transition name="fade">
                    <div
                        v-if="hasSupplier"
                        class="request-handling-supplier__details"
                    >
                        <BRow>
                            <BCol
                                md="6"
                                lg="6"
                            >
                                <BFormGroup
                                    :label="supplierProductNameLabel"
                                    label-for="request-handling-supplier-product-name"
                                >
                                    <BFormInput
                                        id="request-handling-supplier-product-name"
                                        class="input-bg-warning"
                                        :value="details.name"
                                        :state="supplierProductNameState"
                                        @input="changeField('name', $event)"
                                    />
                                </BFormGroup>
                            </BCol>

                            <BCol
                                md="6"
                                lg="6"
                            >
                                <BFormGroup
                                    :label="supplierProductIdentifierLabel"
                                    label-for="request-handling-supplier-product-identifier"
                                >
                                    <BFormInput
                                        id="request-handling-supplier-product-identifier"
                                        :value="details.identifier"
                                        @input="changeField('identifier', $event)"
                                    />
                                </BFormGroup>
                            </BCol>
                        </BRow>

                        <div
                            v-if="showForwardAction"
                            class="request-handling-supplier__footer"
                        >
                            <BButton
                                variant="primary"
                                :disabled="forwardDisabled"
                                @click="$emit('forward')"
                            >
                                {{ translate(
                                    'Component(Button):forward-to-supplier',
                                    'Forward request to supplier',
                                ) }}
                            </BButton>
                        </div>
                    </div>
                </Transition>
            </template>
        </SupplierSelector>
    </div>
</template>

<script>
import {
    BButton,
    BCol,
    BFormGroup,
    BFormInput,
    BRow,
} from 'bootstrap-vue'
import { SupplierSelector } from '@core/components/supply-chain'
import { ProductIdentifiers, ProductNames } from '@/libs/product'

export default {
    name: 'RequestHandlingProductSupplierDetails',
    components: {
        BButton,
        BCol,
        BFormGroup,
        BFormInput,
        BRow,
        SupplierSelector,
    },
    props: {
        details: {
            type: Object,
            required: true,
        },
        productAttributes: {
            type: Object,
            default: null,
        },
        showForwardAction: {
            type: Boolean,
            default: true,
        },
        forwardDisabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        addSupplierLabel() {
            return this.translate(
                'Page(ReceivedRequest):Component(RequestHandling):add-supplier',
                'Add supplier',
            )
        },
        hasSupplier() {
            return Array.isArray(this.details.suppliers) && this.details.suppliers.length > 0
        },
        supplierProductNameState() {
            return this.hasSupplier && this.details.name.trim().length > 0
        },
        supplierProductNameLabel() {
            return this.getAttributeLabel(
                'ProductName',
                ProductNames.SUPPLIERS_PRODUCT_NAME,
                'Supplier product name',
            )
        },
        supplierProductIdentifierLabel() {
            return this.getAttributeLabel(
                'ProductId',
                ProductIdentifiers.SUPPLIERS_PRODUCT_ID,
                'Supplier product ID',
            )
        },
    },
    methods: {
        getAttributeLabel(type, key, fallback) {
            const attributes = this.productAttributes
            const attribute = attributes && Array.isArray(attributes[type])
                ? attributes[type].find(item => item.key === key)
                : null

            return attribute ? attribute.title : fallback
        },
        translate(key, fallback) {
            const translation = this.$t(key)
            return translation && translation !== key ? translation : fallback
        },
        changeField(field, value) {
            this.emitChange({ [field]: value })
        },
        changeSuppliers(ids, suppliers) {
            this.emitChange({ suppliers })
        },
        emitChange(partialDetails) {
            this.$emit('change', {
                ...this.details,
                ...partialDetails,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.request-handling-supplier__details {
    padding: 1.25rem;
    border-top: 1px solid #ebe9f1;
}

.request-handling-supplier__footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 1rem;
    border-top: 1px solid #ebe9f1;
}
</style>
